export default "__VITE_ASSET__kEG__ZeX__"